import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Row, Col, Label, Tooltip, Button, Modal, ModalHeader, ModalBody, ModalFooter  } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { cancelToken } from "../../../../../services/adapters/kepegawaian/organizationhistoriService"

import DataTableBloc from '../../Pegawai/Blocs/DataTableBloc'
import ApproveBloc from '../Blocs/ApproveBloc'
import apiResponse from '../../../../../services/apiResponse'

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();
    approveBloc = new ApproveBloc();

    source
    historyTable = 'AwardRecomendationTableActive'
    defaultOrder = 'award_type_name'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            revokeUuid: null,
            inactiveUuid: null,
            rejectUuid: null,
            selectedInactive: null,
            recomendationUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    makeid(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }
    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            uuid: this.props.uuid,
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                if (this.state.selectedInactive != null) {
                    this.inactiveData()
                }
                if (this.state.revokeUuid != null) {
                    this.revokeData()
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive(this.state.dataForm)
    }

    revokeData = async () => {
        const query = {
            uuid: this.state.revokeUuid
        }
        await this.approveBloc.fetchRevoke(query)
    }


    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true,
                        selectedInactive: null 
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.approveBloc.revokeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true,
                        revokeUuid: null
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel?.unsubscribe()
        this.dataTableBloc.inactiveChannel?.unsubscribe()
        this.approveBloc.revokeChannel?.unsubscribe()
    }

    columns = [
        {
            key: "employee_nip",
            text: "NIP",
            sortable: false,
        },
        {
            key: "employee_full_name",
            text: "Nama",
            sortable: false,
        },
        {
            key: "award_type_name",
            text: "Jenis Penghargaan",
            sortable: false,
        },
        {
            key: "approval_status",
            text: "Status",
            sortable: false,
            cell: record => {
                if (record.approval_status) {
                    let status = parseInt(record.approval_status)
                    if (status == 1) {
                        status = <label className="badge rounded-pill bg-soft-success font-size-12" >Disetujui</label>
                    } else if (status == 2) {
                        status = <label className="badge rounded-pill bg-soft-warning font-size-12" >Ditolak</label>
                    } else {
                        status = <label className="badge rounded-pill bg-soft-info font-size-12" >Menunggu Persetujuan</label>
                    }
                    return <span> {status} </span>
                }
                return <label className="badge rounded-pill bg-soft-info font-size-12" >Rekomendasi</label>
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.award_uuid
                const thisUuid = record.award_uuid
                const recomendationUuid = record.recomended_award_uuid !== null ? record.recomended_award_uuid : null
                return (
                    <Fragment>
                        {/* <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: thisUuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-align-left"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Detil</Tooltip>
                        </span> */}
                        { record.approval_status == 1 &&
                            <Fragment>
                                <span>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        id={"detail-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                detailUuid: thisUuid,
                                                confirm: true
                                            })
                                        }}
                                        style={{
                                            marginRight: '2px',
                                            padding: '2px 5px'
                                        }}>
                                            <i className="uil-align-left"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["detail" + thisId] : !this.state["detail" + thisId]
                                            })
                                        }}
                                    >Detail</Tooltip>
                                </span>
                                <span>
                                    <button
                                        className="btn btn-danger btn-sm"
                                        id={"revoke-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                revokeUuid: thisUuid,
                                                confirm: true
                                            })
                                        }}
                                        style={{
                                            marginRight: '2px',
                                            padding: '2px 5px'
                                        }}>
                                            <i className="uil-user-times"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["revoke" + thisId]} target={"revoke-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["revoke" + thisId] : !this.state["revoke" + thisId]
                                            })
                                        }}
                                    >Batalkan Approval</Tooltip>
                                </span>
                            </Fragment>
                        }
                        { record.approval_status != 1 &&
                            <Fragment>
                                { accessRole('update') &&
                                    <span>
                                        <button
                                            className="btn btn-success btn-sm"
                                            id={"update-" + thisId}
                                            onClick={() => {
                                                this.setState({
                                                    updateUuid: thisUuid,
                                                    recomendationUuid: recomendationUuid
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-user-check"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["update" + thisId] : !this.state["update" + thisId]
                                                })
                                            }}
                                        >Approve</Tooltip>
                                    </span>
                                }
                            </Fragment>
                        }
                        {/* { record.approval_status != 1 &&
                            <Fragment>
                                { accessRole('approve') &&
                                    <span>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            id={"reject-" + thisId}
                                            onClick={() => {
                                                this.setState({
                                                    rejectUuid: thisUuid,
                                                })
                                            }}
                                            style={{
                                                marginRight: '2px',
                                                padding: '2px 5px'
                                            }}>
                                                <i className="uil-user-times"></i>
                                        </button>
                                        <Tooltip
                                            style={{
                                                marginBottom: 2
                                            }}
                                            placement="top" isOpen={this.state["reject" + thisId]} target={"update-" + thisId}
                                            toggle={() => {
                                                this.setState({
                                                    ["reject" + thisId] : !this.state["reject" + thisId]
                                                })
                                            }}
                                        >Hapus Pegawai Dari Daftar Rekomendasi</Tooltip>
                                    </span>
                                }
                            </Fragment>
                        } */}

                        {record.approval_status != 1 &&
                            <span>
                                <button
                                    className="btn btn-danger btn-sm"
                                    id={"delete-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            inactiveUuid: thisUuid,
                                            selectedInactive: record
                                        })
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-trash"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["delete" + thisId] : !this.state["delete" + thisId]
                                        })
                                    }}
                                >Kecualikan Pegawai Dari Daftar Rekomendasi</Tooltip>
                            </span>
                        }

                    </Fragment>
                );
            }
        }

    ]

    render() {
        const { selectedInactive } = this.state
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />

                <Modal isOpen={selectedInactive ? true : false} toggle={() => this.setState({ selectedInactive: null })} size="lg">
                    <ModalHeader toggle={() => this.setState({ selectedInactive: null })}>Hapus Pegawai Dari Daftar Rekomendasi</ModalHeader>
                    <ModalBody>
                        <AvForm
                            className="needs-validation"
                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                        >
                            <AvField 
                                name="uuid"
                                type="hidden"
                                errorMessage="Masukkan Periode"
                                value={selectedInactive?.award_uuid}
                            />
                            <Row className="mb-3">
                                <Label className="col-md-2 col-form-label">
                                    Pegawai
                                </Label>
                                <Label className="col-md-4 col-form-label">
                                    {selectedInactive?.employee_full_name}
                                </Label>
                                <AvField 
                                    name="award_exception_employee_uuid"
                                    type="hidden"
                                    value={selectedInactive?.employee_uuid}
                                    validate={{ required: { value: true } }}
                                />
                            </Row>                       
                            <Row className="mb-3">
                                <Label className="col-md-2 col-form-label">
                                    Penghargaan
                                </Label>
                                <Label className="col-md-4 col-form-label">
                                    {selectedInactive?.award_type_name}
                                </Label>
                                <AvField 
                                    name="award_exception_award_type_uuid"
                                    type="hidden"
                                    errorMessage="Masukkan Periode"
                                    value={selectedInactive?.recomended_award_uuid}
                                    validate={{ required: { value: true } }}
                                />
                            </Row>

                            <Row className="mb-3">
                                <Label className="col-md-2 col-form-label">
                                    Catatan
                                </Label>
                                <Col md="8">
                                    <AvField 
                                        name="award_exception_note"
                                        placeholder="Catatan..."
                                        type="textarea"
                                    />
                                </Col>
                            </Row>
                            
                            <ModalFooter>
                                <Button color="secondary" onClick={() => this.setState({ selectedInactive: null })}>Cancel</Button>
                                <Button color="primary" type="submit">Submit</Button>
                            </ModalFooter>
                        </AvForm>
                    </ModalBody>
                </Modal>

                { this.state.detailUuid !== null ?
                    <Redirect to={`/kepegawaian/pemberian_penghargaan.html?pegawai&detail&uuid=${this.props.uuid}&award_uuid=${this.state.detailUuid}`}/>
                : null }
                { this.state.updateUuid !== null ?
                    <Redirect to={`/kepegawaian/pemberian_penghargaan.html?pegawai&approve&uuid=${this.props.uuid}&award_uuid=${this.state.updateUuid}`}/>
                : null }
                { this.state.rejectUuid !== null &&
                    <Redirect to={`/kepegawaian/pemberian_penghargaan.html?pegawai&reject&uuid=${this.props.uuid}&award_uuid=${this.state.rejectUuid}`}/>
                }
            </>
        )
    }

}

export default TableActiveComponent